import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f58999b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-reset_password com_bg1" }
const _hoisted_2 = { id: "wrapper1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/WITH_AG_PORTAL/images/with-kaunet_logo2.png",
  alt: "ウィズカウネット エージェントポータル",
  class: "with-kaunet_logo2",
  style: {"margin-top":"0"}
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "com_form_contet1"
}
const _hoisted_5 = { class: "inner1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1 com_mgb30" }, " パスワード再設定のメールを送信しました ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_center1 com_mgb30" }, [
  /*#__PURE__*/_createTextVNode(" パスワード再設定はまだ完了しておりません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メール本文に記載のURLからお手続きを完了させてください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メールが届かない場合はエージェントコールまでお問い合わせください。 ")
], -1))
const _hoisted_8 = {
  key: 1,
  class: "com_form_contet1"
}
const _hoisted_9 = { class: "inner1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, "パスワード再設定", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_left1 com_mgb30" }, " パスワードを再設定するために、エージェントコードとログインIDで使用されているメールアドレスを入力してください。 メールアドレスに仮登録URLをお送りします。 ", -1))
const _hoisted_12 = { class: "form1" }
const _hoisted_13 = { class: "group1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "agentCode" }, "エージェントコード", -1))
const _hoisted_15 = { class: "group1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "メールアドレス", -1))
const _hoisted_17 = {
  key: 0,
  class: "group1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1))
const _hoisted_19 = { class: "error-message" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_left1 com_mgt20" }, [
  /*#__PURE__*/_createTextVNode(" ※仮登録URLが届かない場合はエージェントコード、もしくはメールアドレスが異なっている可能性があります。カウネットからのご案内、もしくは管理者からのご案内をご確認ください。"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "com_center1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_copyright1" }, "© 2025 Kaunet", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AlphanumericInput = _resolveComponent("AlphanumericInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isSendMail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createVNode(_component_router_link, {
                to: "/login",
                class: "com_button1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("ログインページ")
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_AlphanumericInput, {
                    id: "agentCode",
                    modelValue: _ctx.agCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agCode) = $event)),
                    type: "text",
                    laceholder: "",
                    maxlength: "20"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    id: "mailAddress",
                    placeholder: "sample@agweb.kaunet.com",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                    maxlength: "255"
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.errorMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_20,
                _createElementVNode("button", {
                  type: "submit",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendResetMail && _ctx.sendResetMail(...args))),
                  disabled: _ctx.isProcessing
                }, " 送信 ", 8, _hoisted_21),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "com_link1 com_fs15 arr1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ログインページへ戻る")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])),
      _hoisted_23
    ])
  ]))
}